module.exports = __webpack_public_path__ + "img/Outubro_Rosa_630x200.9b99c352.jpg";